import { PageSection } from '@/components/common/PageSection';
import { SectionHeading } from '@/components/common/SectionHeading';
import { cn } from '@/lib/utils';
import { Story } from '@/pages/About/data';

const SectionId = 'story';
const TitleId = 'story-title';

export function StorySection() {
  return (
    <PageSection id={SectionId} titleId={TitleId}>
      <div className="grid gap-8 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-4">
          <SectionHeading id={TitleId} title={Story.title} />
        </div>
        <div className="space-y-5 lg:col-span-8">
          {Story.paragraphs.map((paragraph, paragraphIndex) => (
            <p
              key={paragraph}
              className={cn('max-w-[62ch] leading-relaxed', paragraphIndex === 0 ? 'text-xl text-graphite' : 'text-lg text-steel')}
            >
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </PageSection>
  );
}